import React, { Suspense, Fragment } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Loader from "../Layout/Loader";
import LayoutRoutes from "./LayoutRoutes";
import PrivateRoute from "./PrivateRoute";

import SignIn from "../Modules/Auth/Signin";

const Routers = () => {
  const login = JSON.parse(localStorage.getItem("authenticated"))
    ? JSON.parse(localStorage.getItem("authenticated"))
    : false;

  return (
    <Fragment>
      <BrowserRouter
        basename="/"
        future={{
          v7_startTransition: true,
        }}
      >
        <Suspense fallback={<Loader />}>
          <Routes>
            {login ? (
              <>
                <Route
                  path={`${process.env.PUBLIC_URL}`}
                  element={
                    <Navigate to={`${process.env.PUBLIC_URL}/app/contacts`} />
                  }
                />
                <Route
                  path={`/`}
                  element={
                    <Navigate to={`${process.env.PUBLIC_URL}/app/contacts`} />
                  }
                />
              </>
            ) : (
              ""
            )}
            <Route path={"/"} element={<PrivateRoute />}>
              <Route path={`/*`} element={<LayoutRoutes />} />
            </Route>
            <Route
              path={`${process.env.PUBLIC_URL}/login`}
              element={<SignIn />}
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </Fragment>
  );
};
export default Routers;
